import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMoveSearchResultsCountQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  searchInputNumber: Types.Scalars['bigint']['input'];
  searchInputString: Types.Scalars['String']['input'];
}>;


export type GetMoveSearchResultsCountQuery = { __typename?: 'query_root', moves_aggregate: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null } };


export const GetMoveSearchResultsCountDocument = gql`
    query getMoveSearchResultsCount($start: timestamptz!, $end: timestamptz!, $searchInputNumber: bigint!, $searchInputString: String!) {
  moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, _and: [{_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}], _or: [{id: {_eq: $searchInputNumber}}, {consumer_name: {_ilike: $searchInputString}}, {consumer_phone: {_ilike: $searchInputString}}, {customer: {name: {_ilike: $searchInputString}}}, {lane: {description: {_ilike: $searchInputString}}}, {lane: {pickup: {name: {_ilike: $searchInputString}}}}, {lane: {delivery: {name: {_ilike: $searchInputString}}}}, {lane: {pickup: {address: {_ilike: $searchInputString}}}}, {lane: {delivery: {address: {_ilike: $searchInputString}}}}, {reference_num: {_ilike: $searchInputString}}, {vehicle_make: {_ilike: $searchInputString}}, {vehicle_model: {_ilike: $searchInputString}}, {vehicle_stock: {_ilike: $searchInputString}}, {vehicle_vin: {_ilike: $searchInputString}}, {vehicle_year: {_ilike: $searchInputString}}]}
    order_by: {ready_by: desc}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMoveSearchResultsCountQuery__
 *
 * To run a query within a React component, call `useGetMoveSearchResultsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveSearchResultsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveSearchResultsCountQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      searchInputNumber: // value for 'searchInputNumber'
 *      searchInputString: // value for 'searchInputString'
 *   },
 * });
 */
export function useGetMoveSearchResultsCountQuery(baseOptions: Apollo.QueryHookOptions<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables> & ({ variables: GetMoveSearchResultsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>(GetMoveSearchResultsCountDocument, options);
      }
export function useGetMoveSearchResultsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>(GetMoveSearchResultsCountDocument, options);
        }
// @ts-ignore
export function useGetMoveSearchResultsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>;
export function useGetMoveSearchResultsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMoveSearchResultsCountQuery | undefined, GetMoveSearchResultsCountQueryVariables>;
export function useGetMoveSearchResultsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>(GetMoveSearchResultsCountDocument, options);
        }
export type GetMoveSearchResultsCountQueryHookResult = ReturnType<typeof useGetMoveSearchResultsCountQuery>;
export type GetMoveSearchResultsCountLazyQueryHookResult = ReturnType<typeof useGetMoveSearchResultsCountLazyQuery>;
export type GetMoveSearchResultsCountSuspenseQueryHookResult = ReturnType<typeof useGetMoveSearchResultsCountSuspenseQuery>;
export type GetMoveSearchResultsCountQueryResult = Apollo.QueryResult<GetMoveSearchResultsCountQuery, GetMoveSearchResultsCountQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/searchResults/queries/getMoveSearchResultsCount.query.gql}
 */
export async function getMoveSearchResultsCount(
  variables: GetMoveSearchResultsCountQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMoveSearchResultsCountQuery['moves_aggregate']>
export async function getMoveSearchResultsCount(
  variables: GetMoveSearchResultsCountQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMoveSearchResultsCountQuery>
export async function getMoveSearchResultsCount(
  variables: GetMoveSearchResultsCountQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMoveSearchResultsCountQuery['moves_aggregate'] | GetMoveSearchResultsCountQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMoveSearchResultsCountQuery>(
    GetMoveSearchResultsCountDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves_aggregate
}